module.exports = __webpack_public_path__ + "img/cod.cd346cdc.svg";